import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ApiServices } from '../../services/api.service';
import { DataService } from '../../services/data.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import * as $ from 'jquery';




@Component({
  selector: 'app-search-by-vehicle',
  templateUrl: './search-by-vehicle.component.html',
  styleUrls: ['./search-by-vehicle.component.css']
})
export class SearchByVehicleComponent implements OnInit {

  queryParams: Params;
  makes = [];
  models = [];
  years = [];
  modifications = [];
  subModel:any = '';

  makeSubscription: Subscription;
  modelSubscription: Subscription;
  yearSubscription: Subscription;
  modiSubscription: Subscription;
  vehicleSubscription: Subscription;
  isLoading = false;

  form: FormGroup;
  loadMake = false;
  loadModels = false;
  loadYear = false;
  loadModi = false;
  loadVehicle = false;

  bodyImage = null



  constructor( private apiService: ApiServices, private formService: FormService, private dataService: DataService, private router: Router, private route: ActivatedRoute, public helperService: HelperService) { 
    this.form = this.formService.searchForm();
  }

  ngOnInit(): void {
    this.getMakes();
  }
  getMakes = () => {
    this.loadMake = true;
    this.makeSubscription = this.apiService.getMakes().subscribe(response => {
        // Handle nested data structure: response.data.data
        this.makes = response.data?.data || response.data || response;
        this.loadMake = false;
        console.log('Makes loaded:', this.makes);
      }, error => {
        console.error('Error fetching makes:', error);
        this.loadMake = false;
      }
    );
  }
  onMakeSelect = () => {
    this.loadModels = true;
    this.modelSubscription = this.apiService.getModels(this.form.value.make).subscribe(
      res => {
        // @ts-ignore
        this.models = res.data?.data || res.data || res;
        this.loadModels = false;
        console.log('Models loaded:', this.models);
      }, err => {
        console.error('Error fetching models:', err);
        this.loadModels = false;
      }
    );
  }
  onModelSelect = () => {
    this.loadYear = true;
    this.yearSubscription = this.apiService.getYear(this.form.value.make, this.form.value.model).subscribe(
      resYear => {
        // @ts-ignore
        this.years = resYear.data?.data || resYear.data || resYear;
        this.loadYear = false;
        console.log('Years loaded:', this.years);
      }, err => {
        console.error('Error fetching years:', err);
        this.loadYear = false;
      }
    );
  }
  onYearSelect = () => {
    this.loadModi = true;
    this.modiSubscription = this.apiService.getModifications(this.form.value.make, this.form.value.model, this.form.value.year).subscribe(
      resModi => {
        // @ts-ignore
        // Handle nested data structure: response.data.data for modifications
        this.modifications = resModi.data?.data || resModi.data || resModi;
        console.log('Modifications loaded:', this.modifications);
        this.loadModi = false;
      }, err => {
        console.error('Error fetching modifications:', err);
        this.loadModi = false;
      }
    );
  }
  getSubModelText = () => {
    this.subModel = $( "#sel4 option:selected" ).text();
  };

  onSubmit = () => {
    if (this.form.valid) {
      this.isLoading = true;
      this.vehicleSubscription = this.apiService.getVehicles(this.form.value).subscribe(vehicleResponse => {
          // Handle nested data structure: response.data.data
          const vehicleData = vehicleResponse.data?.data || vehicleResponse.data || vehicleResponse;
          console.log('Vehicle search response:', vehicleResponse);
          console.log('Vehicle data:', vehicleData);
          
          if (vehicleData && vehicleData.length) {
            this.bodyImage = vehicleData[0]?.generation?.bodies[0]?.image;
            localStorage.setItem('bodyImage', JSON.stringify(this.bodyImage))
            localStorage.setItem("hub_bore", vehicleData[0].technical?.centre_bore);
            const param = this.helperService.setVehicleWheelParams(vehicleData);
            this.dataService.setVehiclesData(vehicleData);
            $('.close').click();
            const searchParams = {
              year: this.form.value.year,
              make: this.form.value.make,
              model: this.form.value.model,
              subModel: this.subModel,
              modification: this.form.value.modification,
              searchByVehicle: true,
            };
            const fitmentData = {...param, ...searchParams};
            this.dataService.fitmentData.next(fitmentData);

            // this.router.navigate(['wheels'], { queryParams: {...param, ...searchParams}});
            const params = new URLSearchParams({ ...param, ...searchParams });
            location.href = `/wheels?${params.toString()}`;
            this.isLoading = false;

          } else {
            console.log('No vehicle data found');
            this.isLoading = false;
          }
        }, err => {
          console.error('Error in vehicle search:', err);
          this.isLoading = false;
        }
      );

    } else {
      this.form.markAllAsTouched();
    }
  }

}
